import { Link, useLocation } from 'react-router-dom';
import { event } from '../content/event';

function readConfirmation(routeState) {
  if (routeState) return routeState;
  try { return JSON.parse(sessionStorage.getItem('bbabdt-confirmation')) || {}; }
  catch (_error) { return {}; }
}

function ThankYou() {
  const { state } = useLocation();
  const confirmation = readConfirmation(state);
  const attending = confirmation.attendanceStatus === 'attending';
  return (
    <main className="confirmation-page">
      <div className="confirmation-card">
        <img src="/cartoon-turkey.png" width="800" height="800" alt="A cheerful cartoon turkey" />
        <p className="eyebrow">Response received</p>
        <h1>{attending ? `You're on the list${confirmation.name ? `, ${confirmation.name}` : ''}!` : 'Thanks for letting us know.'}</h1>
        <p className="confirmation-card__lead">{attending ? `We recorded your RSVP for ${event.displayDate} at ${event.displayTime}.` : `We recorded that you can’t make it this year${confirmation.name ? `, ${confirmation.name}` : ''}. You’ll be missed.`}</p>
        {attending && <p>{event.location} Keep an eye on the email address you submitted.</p>}
        <p className="confirmation-card__fine">Need to make a correction? Submit the RSVP form again and flag the update in your message.</p>
        <Link className="button" to="/">Back to the invitation</Link>
      </div>
    </main>
  );
}

export default ThankYou;
